import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { loadFromCache, getTimestamp, isFresh } from '../utils/cache';
import { useTheme } from '../context/ThemeContext';

import '../styles/Header.css';

import SplitText from "./react bits/SplitText";
import CircularText from './react bits/CircularText';

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const { theme, toggleTheme } = useTheme();
  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false); // New state for search bar visibility
  const [issues, setIssues] = useState([]); // 내부 상태로 추가
  const [dailyIssues, setDailyIssues] = useState(null); // 내부 상태로 추가

  useEffect(() => {
    // 라우트 변경 시 검색창 초기화
    setSearchTerm("");
    setResults([]);
    setShowResults(false);
  }, [location.pathname]);

  // 컴포넌트 마운트 시 캐시에서 데이터 로드
  useEffect(() => {
    const cachedIssues = loadFromCache('cachedIssueSummaries');
    const cachedDailyIssues = loadFromCache('cachedDailyIssues');

    if (cachedIssues && isFresh(getTimestamp('issueSummariesTimestamp'))) {
      setIssues(cachedIssues);
    }

    if (cachedDailyIssues && isFresh(getTimestamp('dailyIssuesTimestamp'))) {
      setDailyIssues(cachedDailyIssues);
    }
  }, []); // 빈 배열: 컴포넌트 마운트 시 한 번만 실행

  // 검색어 필터링
  useEffect(() => {
    if (!searchTerm) {
      // results가 이미 비어있지 않다면 비우기
      if (results.length > 0) {
        setResults([]);
      }
      return;
    }
    const issueKeywords = issues.map(doc => doc.keyword);
    const keywordTexts = dailyIssues?.keywords?.map(k => k.text) || [];
    const all = Array.from(new Set([...issueKeywords, ...keywordTexts]));
    const filtered = all.filter(
      k => typeof k === "string" && k.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const newResults = filtered.slice(0, 10);
    // 결과 내용이 실제로 변경되었을 때만 상태 업데이트
    if (JSON.stringify(newResults) !== JSON.stringify(results)) {
      setResults(newResults);
    }
  }, [searchTerm, issues, dailyIssues, results]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setShowResults(true);
  };

  const handleResultClick = (keyword) => {
    setSearchTerm(keyword);
    setResults([]);
    setShowResults(false);
  };

  const handleSearchSubmit = (e) => {
    if (e?.preventDefault) e.preventDefault();
    const trimmed = (searchTerm || "").trim();
    if (!trimmed) return;
    setResults([]);
    setShowResults(false);
    navigate(`/issue/${encodeURI(trimmed)}`);
  };

  const handleLogoClick = () => {
    navigate('/', { state: { resetPage: true } });
  };

  return (
    <header className="header">
      <div className="logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
        <span className="logo-text">Struggle</span>
        <span className="logo-portal"></span>
        {/* <CircularText
          text="Struggle"
          onHover="speedUp"
          spinDuration={12}
          className="custom-class"
        /> */}
      </div>
      
      <div className="mobile-controls">

        {/* <div className="search-icon" onClick={() => setIsSearchOpen(!isSearchOpen)}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24px" height="24px">
            <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
          </svg>
        </div> */}
        <div className={`hamburger ${isMenuOpen ? "open" : ""}`} onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div className={`header-right ${isMenuOpen ? "open" : ""}`}>
        <Link to="/editorial" className="nav-link">사설</Link>
        {/* <Link to="/" className="nav-link">날짜별 기사</Link> */}
        <Link to="/outlet" className="nav-link">언론사 정보</Link>
        <a href="https://news.naver.com/ombudsman/errorArticleList" target="_blank" rel="noopener noreferrer" className="nav-link">
          정정보도 모음
        </a>
        {/* <Link to="/about" className="nav-link">소개</Link>
        <Link to="/contact" className="nav-link">문의</Link> */}
        <form className="search-container" style={{ position: 'relative' }} onSubmit={handleSearchSubmit}>
          <input
            type="text"
            className="search-input"
            placeholder="이슈나 키워드를 검색하세요..."
            value={searchTerm}
            onChange={handleSearch}
          />
          <button className="search-button" aria-label="검색" type="submit">이동</button>
          {showResults && searchTerm && results.length > 0 && (
            <ul className="search-results-dropdown">
              {results.map((k, i) => (
                <li key={i} onClick={() => handleResultClick(k)}>
                  {k}
                </li>
              ))}
            </ul>
          )}
        </form>

      </div>
    </header>
  );
}
